import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App/App';
import Signin from 'pages/Signin/Signin';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/authProvider'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './components/utils/axiosInterceptor'; // Initialize axios interceptors
require('styles/index.scss');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path ='*' element={<App />}/>
        </Routes>
      </AuthProvider>
      </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
